export const PUBLIC_LAYOUT_X_PADDING = 'px-8'
